import React from "react";
import { Stack } from "@mui/material";
import CollapsibleSection from "@hyro-components/CollapsibleSection";
import CountChip from "./CountChip";
import ReviewEntry from "./ReviewEntry";

// A collection (Skills, Knowledge, ...) and its changed resources, collapsible like the page's sections.
const ReviewGroup = ({ group, expanded = false }) => (
  <CollapsibleSection title={group.title} defaultExpanded={expanded} headerRight={<CountChip count={group.count} />}>
    <Stack gap={1.5} data-testid={`review-group-${group.key}`}>
      {group.entries.map((entry) => (
        <ReviewEntry key={entry.key} entry={entry} defaultExpanded={expanded} />
      ))}
    </Stack>
  </CollapsibleSection>
);

export default ReviewGroup;
